import { Component } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'exa-cass-account-regenerate-cell',
  template: `
    <div class="regenerate__info" *ngIf="params?.data">
      <span class="regenerate__date" *ngIf="date">{{date}}</span>
      <span class="regenerate__by" *ngIf="date && regeneratedBy">by {{regeneratedBy}}</span>
    </div>
  `,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .regenerate__info {
      display: flex;
      flex-direction: column;
      min-width: 0;
      font-size: 12px;
      line-height: 18px;
      color: #757575;
    }

    .regenerate__by {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `],
})
export class CassAccountRegenerateCellComponent {
  params: any;
  date: string;
  regeneratedBy: string;

  agInit(params: any) {
    this.params = params;
    const data = params.data || {};
    this.date = data.last_regenerated_on
      ? moment.utc(data.last_regenerated_on).local().format('MM/DD/YYYY hh:mm A')
      : null;
    this.regeneratedBy = data.last_regenerated_by;
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }
}
